const initialState = {
  data: null,
  adventures: null,

  fetching: false,
  fetched: false,

  fetchingAdventures: false,
  fetchedAdventures: false,
  creatingAdventures: false,

  creating: false,
  updating: false,
  uploading: false,

  error: null,
  redirectAfterFormSubmit: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'MY_STORY_RESET':
      return initialState

    case 'MY_STORY_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'MY_STORY_FETCH_REJECTED':
    case 'MY_STORY_FETCH_SILENT_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case 'MY_STORY_FETCH_FULFILLED':
    case 'MY_STORY_FETCH_SILENT_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }

    case 'MY_STORY_UPDATE_PENDING':
      return {
        ...state,
        updating: true,
      }

    case 'MY_STORY_UPDATE_REJECTED':
    case 'MY_STORY_UPDATE_SILENT_REJECTED':
      return {
        ...state,
        updating: false,
        error: action.payload,
      }

    case 'MY_STORY_UPDATE_FULFILLED':
    case 'MY_STORY_UPDATE_SILENT_FULFILLED':
      return {
        ...state,
        data: action.payload.data,
        updating: false,
      }

    case 'MY_STORY_SET_REDIRECT':
      return {
        ...state,
        redirectAfterFormSubmit: action.payload,
      }

    case 'MY_STORY_RESET_REDIRECT':
      return {
        ...state,
        redirectAfterFormSubmit: null,
      }

    case 'MY_STORY_ADVENTURES_FETCH_PENDING': {
      return {
        ...state,
        fetchingAdventures: true,
      }
    }

    case 'MY_STORY_ADVENTURES_FETCH_REJECTED': {
      return {
        ...state,
        fetchingAdventures: false,
        error: action.payload,
      }
    }

    case 'MY_STORY_ADVENTURES_FETCH_FULFILLED': {
      return {
        ...state,
        fetchingAdventures: false,
        fetchedAdventures: true,
        adventures: action.payload.data,
      }
    }

    case 'MY_STORY_ADVENTURES_ORDER_REJECTED':
    case 'MY_STORY_ADVENTURES_FETCH_SILENT_REJECTED': {
      return {
        ...state,
        error: action.payload,
      }
    }

    case 'MY_STORY_ADVENTURES_ORDER_FULFILLED':
    case 'MY_STORY_ADVENTURES_FETCH_SILENT_FULFILLED': {
      return {
        ...state,
        adventures: action.payload.data,
      }
    }

    case 'MY_STORY_ADVENTURES_CREATE_PENDING': {
      return {
        ...state,
        creatingAdventures: true,
      }
    }

    case 'MY_STORY_ADVENTURES_CREATE_REJECTED': {
      return {
        ...state,
        creatingAdventures: false,
        error: action.payload,
      }
    }

    case 'MY_STORY_ADVENTURES_CREATE_FULFILLED':
    case 'MY_STORY_ADVENTURES_UPDATE_FULFILLED':
    case 'MY_STORY_ADVENTURES_DELETE_FULFILLED': {
      return {
        ...state,
        creatingAdventures: false,
        adventures: action.payload.data,
      }
    }

    default:
      return state
  }
}
